import { useCallback, useRef, useState } from 'react';
import { openHeadlessOAuthWindow } from './openHeadlessOAuthWindow';
/**
 * Single owner of the headless gesture→popup→restart concern, shared by every
 * trigger (button / useModal / useUnifiedAccount) so the logic lives in one
 * place instead of being copied per trigger.
 */
export function useHeadlessOAuthLauncher(mode, appName) {
  const windowRef = useRef(null);
  const [flowKey, setFlowKey] = useState(0);
  const openOAuthPopup = useCallback(() => {
    if (mode !== 'headless') {
      return;
    }
    if (windowRef.current && !windowRef.current.closed) {
      windowRef.current.close();
    }
    windowRef.current = openHeadlessOAuthWindow(appName);
    setFlowKey(n => n + 1);
  }, [mode, appName]);

  // oAuthWindow is a ref read at render time. openOAuthPopup both writes the ref
  // and calls setFlowKey, which schedules a re-render. By the time that render
  // runs, windowRef.current holds the newly opened window, so the snapshot is
  // always fresh when consumers actually read it (React batches the state update
  // with whatever other state change triggered the re-render).
  // eslint-disable-next-line react-hooks/refs
  return {
    openOAuthPopup,
    oAuthWindow: windowRef.current,
    flowKey
  };
}